var scope_0 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/23e8e773b1810e1d60ae2afdc4b62699.js').default;
var scope_1 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4e164a2d76602643f6fab48903e98037.js').default;
var scope_2 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5d4f98cc8f0214129a688146910a1286.js').default;
var scope_3 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec30c3f40f86dcd46b5a5a0a1c8441d9.js').default;
var scope_5 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f298b6470bd039db2fdac26583fe7cde.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    